import { gql } from "@apollo/client";

export const GET_WEB_PAGE = gql`
  query WebPage($path: String) {
    webPage(path: $path) {
      id
      content
      style
      script
      metatags {
        robots
        canonicalUrl
        title
        keywords
        description
      }
    }
  }
`;
